import React, {useEffect, useState} from 'react'

import {
    Grid,
    TextField,
    makeStyles, Select, MenuItem, InputLabel, FormControl
} from '@material-ui/core'
import {blue} from "@material-ui/core/colors"
import {useDebouncedCallback} from 'use-debounce'
import {useDispatch, useSelector} from "react-redux";
import {DictionaryActions} from "../../actions/dictionary";
import {Grid as GridTable} from "../../../App/components/Table/Grid";
import format from "date-fns/format";
import {ru} from "date-fns/locale";
import {CustomPaging, IntegratedSelection, PagingState, SelectionState} from "@devexpress/dx-react-grid";
import {
    DragDropProvider, PagingPanel,
    Table,
    TableColumnReordering,
    TableColumnResizing, TableColumnVisibility, TableHeaderRow, TableSelection
} from "@devexpress/dx-react-grid-material-ui";
import {StickyTable} from "../../../App/components/Table/StikyTable";
import {TableHeaderContent} from "./Dictionary/Table/TableHeaderContent";
import {Pager} from "../../../App/components/Table/Paging/Pager";
import {Description} from "./Description";
import {ColumnChooser} from "../../../Item/components/Table/ColumnChooser";
import {history} from "../../../App/helpers/history"

const useStyles = makeStyles(theme => ({
    fullWidth: {
        'width': '100%'
    },
    data: {
        'height': 'calc(100% - 72px)',
        'width': '100%'
    },
    element: {
        'width': '100%'
    },
    breadcrumb: {
        'width': '100%',
        'height': '52px'
    },
    active: {
        'height': '41px',
        'background-color': blue[100],
        '&:hover': {
            'background-color': `${blue[50]} !important`
        },
        '& .MuiTableCell-root': {
            'white-space': 'break-spaces',
        }
    },
    default: {
        'height': '41px',
        '&:hover': {
            'background-color': `${blue[50]} !important`
        },
        '& .MuiTableCell-root': {
            'white-space': 'break-spaces',
        }
    },
    loading: {
        'height': '41px',
        'background-color': 'rgba(244, 244, 244, 1)',
        '&:hover': {
            'background-color': `${blue[50]} !important`
        },
        '& .MuiTableCell-root': {
            'white-space': 'break-spaces',
        }
    },
    body: {
        'height': '100%'
    }
}))

export const Index = (props) => {
    const dispatch = useDispatch()
    const classes = useStyles()

    const {categories, dictionaries, filter} = useSelector(state => state.dictionary)

    const [search, setSearch] = useState('')
    const [category, setCategory] = useState(null)
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)
    const [initialize, setInitialize] = useState(false)

    const columns = [
        { name: 'id', title: '№' },
        { name: 'name', title: 'Справочник' },
        { name: 'type', title: 'Тип' },
        { name: 'description', title: 'Описание' },
        { name: 'items', title: 'Количество записей' },
        { name: 'offers', title: 'Предложено значений' },
        { name: 'created', title: 'Дата создания' },
        { name: 'updated', title: 'Дата обновления' }
    ]

    const [tableRef, setTableRef] = useState(null)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [select, setSelect] = useState(null)
    const [selection, setSelection] = useState([])
    const [columnWidths, setColumnWidths] = useState([
        { columnName: 'id', width: 100 },
        { columnName: 'name', width: 450 },
        { columnName: 'type', width: 200 },
        { columnName: 'description', width: 450 },
        { columnName: 'items', width: 175 },
        { columnName: 'offers', width: 175 },
        { columnName: 'created', width: 200 },
        { columnName: 'updated', width: 200 }
    ])
    const [columnOrder, setColumnOrder] = useState(['id', 'name', 'type', 'description', 'items', 'offers', 'created', 'updated'])
    const [hiddenColumnNames, setHiddenColumnNames] = useState(['items', 'offers', 'created', 'updated'])

    const debounced = useDebouncedCallback(
        (value) => {
            setLoading(value)
        }, 700
    )

    useEffect(() => {
        const getData = async () => {
            return await dispatch(DictionaryActions.dictionaries({
                page: page,
                limit: rowsPerPage,
                ...(search ? {search: search} : {}),
                ...(category ? {category: category} : {}),
                ...((filter.sort.name && filter.sort.direction) ? {order: [filter.sort.name, filter.sort.direction]} : []),
                ...((filter.hasOwnProperty('name') && filter.name.length) ? {name: filter.name} : [])
            }))
        }

        if (!loading) {
            if (!initialize) {
                dispatch({type: 'DICTIONARIES_CLEAR'})

                const getCategories = async () => {
                    return dispatch(DictionaryActions.categories())
                }

                getCategories().then(props => {
                    setInitialize(true);
                })
            }

            getData().then(props => {
                tableRef && tableRef.current && tableRef.current.scrollIntoView()
                setLoading(true)
                setSelection([])
            })
        }
    }, [loading, page, rowsPerPage, search])

    useEffect(() => {
        setPage(1)
        setLoading(false)
    }, [filter])

    return initialize ? (
        <Grid container direction="row" justify="flex-start" alignItems="flex-start" className={ classes.body } spacing={2}>
            <Grid item className={classes.element}>
                <Grid container direction="row" justify="space-between" alignItems="flex-end">
                    <Grid item sm={2}>
                        <FormControl fullWidth>
                            <InputLabel>Категории</InputLabel>
                            <Select
                                value={category ?? ''}
                                onChange={(e) => {
                                    setCategory(e.target.value)
                                    setLoading(false)
                                }}
                            >
                                {[<MenuItem key={0} value="">{'\u00A0\u00A0\u00A0\u00A0'}</MenuItem>].concat(categories.map(category => (
                                    <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                                ))).map(el => el)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item sm={3}>
                        <TextField
                            fullWidth
                            label='Поиск'
                            value={search}
                            onChange={event => {
                                setPage(1)
                                setSearch(event.target.value)
                                debounced.callback(false)
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={classes.breadcrumb}>
                <Grid container direction="row" justify="flex-end" alignItems="center" style={{ height: '38px' }}>
                    <Grid item>
                        <Grid container direction="row" justify="flex-end" alignItems="center" spacing={2}>
                            <Grid item>
                                <ColumnChooser columns={columns} hiddenColumnNames={hiddenColumnNames} setHiddenColumnNames={setHiddenColumnNames} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={classes.data}>
                <GridTable
                    rows={dictionaries.data.map((dictionary, index) => ({
                        'id': ((dictionaries.meta.current_page - 1) * dictionaries.meta.per_page) + (index + 1),
                        'name': dictionary.name,
                        'type': dictionary.attribute ? dictionary.attribute.type.name : 'Словарь',
                        'description': <Description select={select} setSelect={setSelect} dictionary={dictionary} />,
                        'items': dictionary.count.items,
                        'offers': dictionary.count.offers,
                        'created': dictionary.created ? format(new Date(dictionary.created), 'H:mm PP',  {locale: ru}) : null,
                        'updated': dictionary.updated ? format(new Date(dictionary.updated), 'H:mm PP',  {locale: ru}) : null
                    }))}
                    columns={columns}
                >
                    <PagingState
                        currentPage={page}
                        onCurrentPageChange={newPage => {
                            setPage(newPage)
                            setLoading(false)
                        }}
                        pageSize={rowsPerPage}
                        onPageSizeChange={newRowsPerPage => {
                            setPage(1)
                            setRowsPerPage(newRowsPerPage)
                            setLoading(false)
                        }}
                    />
                    <CustomPaging
                        totalCount={dictionaries.data.length ? dictionaries.meta.total : 0}
                    />
                    <SelectionState
                        selection={selection}
                        onSelectionChange={(numbers) => {
                            const current = numbers.filter(x => !selection.includes(x))

                            if (!current.length) {
                                const dictionary = dictionaries.data[selection[0]]
                                history.push(`/dictionary/${((dictionary.key === 'units') ? 'units' : dictionary.id)}/values`)
                            } else {
                                setSelection(numbers.filter(x => !selection.includes(x)))
                            }
                        }}
                    />
                    <IntegratedSelection />
                    <DragDropProvider />
                    <Table
                        noDataCellComponent={props => {
                            return null
                        }}
                        tableComponent={props => <StickyTable onClick={e => e.stopPropagation()} {...props} setTableRef={setTableRef} />}
                        rowComponent={({ row, tableRow, children }) => (
                            <Table.Row
                                tableRow={tableRow}
                                children={children}
                                className={classes.default}
                                row={row}
                            />
                        )}
                    />
                    <TableColumnReordering
                        order={columnOrder}
                        onOrderChange={setColumnOrder}
                    />
                    <TableColumnResizing
                        columnWidths={columnWidths}
                        onColumnWidthsChange={setColumnWidths}
                    />
                    <TableHeaderRow
                        contentComponent={(props) => <TableHeaderContent {...props} category={category} />}
                    />
                    <TableColumnVisibility
                        hiddenColumnNames={hiddenColumnNames}
                        onHiddenColumnNamesChange={setHiddenColumnNames}
                    />
                    <TableSelection
                        selectByRowClick
                        highlightRow
                        showSelectionColumn={false}
                        rowComponent={(props) => {
                            const { tableRow, children, highlighted, onToggle } = props
                            const { row } = tableRow
                            return (
                                <Table.Row
                                    tableRow={tableRow}
                                    children={children}
                                    onClick={() => {
                                        setSelect(row.id)
                                        onToggle()
                                    }}
                                    className={(highlighted || (select === row.id)) ? classes.active : classes.default}
                                    row={row}
                                />
                            )
                        }}
                    />
                    <PagingPanel
                        containerComponent={Pager}
                        messages={{showAll: 'Все', rowsPerPage: 'Записей на странице:', info: '{from}-{to} из {count}'}}
                        pageSizes={[50, 100, 200]}
                    />
                </GridTable>
            </Grid>
        </Grid>
    ) : null
}
